export default (date, years) => {
  let newDate = date;
  if (!(date instanceof Date)) newDate = new Date();

  newDate.setFullYear(newDate.getFullYear() + years);

  return newDate;
};
